import { globalEnv } from "~/global-env";
import { TabConfig } from "./types";

export const getControlTowerTabs = (
  showManagerTabs: boolean,
  hasWorkflowAccess: boolean,
): TabConfig[] => [
  {
    key: "workflows",
    label: "Workflows",
    path: `${globalEnv.controlTowerRoute}/workflows`,
    visible: hasWorkflowAccess,
    testId: "workflows-tab",
  },
  {
    key: "clients",
    label: "Clients",
    path: `${globalEnv.controlTowerRoute}/clients`,
    visible: showManagerTabs,
    testId: "clients-tab",
  },
  {
    key: "individuals",
    label: "Individuals",
    path: `${globalEnv.controlTowerRoute}/individuals`,
    visible: showManagerTabs,
    testId: "individuals-tab",
  },
];
